/** @type {import("@mui/material").SxProps<Theme>} */

const styles = theme => ({
  itemBox: {
    p: 1,
    width: '93%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  editContainer: {
    pr: 2,
    pt: 2,
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      pr: 4,
    },
  },
  summaryContainer: {
    p: 4,
    [theme.breakpoints.down('sm')]: {
      p: '1.5rem 1rem',
    },
  },
  summaryItem: {
    p: '1rem 0 1rem 0',
    [theme.breakpoints.down('md')]: {
      p: '1rem 0.5rem 1rem 0',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '1.5rem',
    p: 2,
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
      textAlign: 'center',
      p: '1.8rem',
      marginBottom: '2.25rem',
    },
  },
  clearCartText: {
    cursor: 'pointer',
    color: theme.palette.primary.buttonColor,
    textDecoration: 'underline',
    textTransform: 'none',
    mr: 1,
  },
  clearCartItem: {
    display: '-webkit-flex',
    cursor: 'pointer',
    padding: '1px 8px 1px 4px',
  },
  clearCartIcon: {
    cursor: 'pointer',
    color: theme.palette.primary.buttonColor,
    textTransform: 'none',
    fontSize: 'medium',
    mr: '-.8rem',
    mt: '0.2rem',
  },
  cartTitle: {
    color: theme.palette.primary.textColor3,
    textAlign: 'center',
  },
  totalPrice: {
    color: theme.palette.primary.textColor3,
    mr: '1.2rem',
    [theme.breakpoints.between('sm', 'lg')]: {
      mr: '4rem',
    },
  },
  monthlyCostTotal: {
    mr: '1.2rem',
    color: theme.palette.primary.textColor3,
    [theme.breakpoints.between('sm', 'md')]: {
      mr: '4rem',
    },
    [theme.breakpoints.up('lg')]: {
      mr: '1.2rem',
    },
  },
  onceOffCost: {
    color: theme.palette.primary.textColor3,
    mr: '1.2rem !important',
    [theme.breakpoints.between('sm', 'md')]: {
      mr: '4rem !important',
    },
    [theme.breakpoints.up('lg')]: {
      mr: '1.2rem !important',
    },
  },
  strikedPrice: {
    textDecoration: 'line-through',
    lineHeight: '1.5rem',
    color: theme.palette.primary.offerPromo,
    [theme.breakpoints.down('lg')]: {
      pl: 0,
    },
  },
  itemContainer: {
    padding: '0 1rem 0rem 1rem',
    [theme.breakpoints.down('sm')]: {
      padding: '0',
    },
  },
  itemDiscountContainer: {
    padding: '0 1rem 0.5rem 1rem',
    [theme.breakpoints.down('sm')]: {
      ml: 0,
      padding: '0 0 0.5rem 0',
    },
  },
  missingItem: {
    [theme.breakpoints.down('sm')]: {
      ml: 0,
      padding: '0 0 0.5rem 0',
    },
  },
  mobileItemDiscountContainer: {
    padding: '0 0rem 0.5rem 0rem',
    [theme.breakpoints.down('sm')]: {
      ml: 0,
      padding: '0 0 0.5rem 0',
    },
  },
  missingStep: {
    width: '96%',
    marginBottom: '8px',
    borderRadius: '4px',
  },
  missingAlert: {
    '& .MuiAlert-icon': {
      color: theme.palette.secondary.asterisk,
      mr: '4px',
    },
    '& .MuiSvgIcon-root': {
      width: '1.25rem',
      height: '1.25rem',
    },
    '& .MuiAlert-action': {
      pl: '0.5rem',
      mr: 0,
      alignItems: 'center',
      textTransform: 'capitalize',
      '& button': {
        whiteSpace: 'nowrap',
        textAlign: 'center',
      },
    },
    '& .MuiAlert-message': {
      paddingLeft: '0.313rem',
    },
    background: `linear-gradient(0deg, ${theme.palette.primary.boxShadow3Dark},  ${theme.palette.primary.boxShadow3Dark}), ${theme.palette.secondary.asterisk}`,
    color: theme.palette.primary.textColor3,
    padding: '2px 8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  missingAlertAction: {
    p: '0 5px',
    background: theme.palette.secondary.asterisk,
    color: theme.palette.secondary.contrastText,
    '&:hover': {
      background: theme.palette.secondary.asterisk,
      color: theme.palette.secondary.contrastText,
    },
  },

  subText: {
    color: theme.palette.primary.textColor5,
  },
  clearCartContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',

    pt: 2,
    pb: 2,
    pr: 2,
    [theme.breakpoints.down('sm')]: {
      p: '1rem 1.5rem 0.5rem 1.5rem',
    },
  },
  editCart: {
    cursor: 'pointer',
  },
  editText: {
    // color: theme.palette.secondary.main,
    // disable them until edit cart functionality is available
    color: theme.palette.primary.main,
    textDecoration: 'underline',
  },
  enableCTA: {
    border: `0.063rem solid ${theme.palette.primary.textColor2}`,
    padding: '8px 24px',
    background: theme.palette.primary.buttonColor,
    color: theme.palette.primary.contrastText,
    // boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow1Dark},0px 10px 14px 1px ${theme.palette.primary.boxShadow1Medium},0px 4px 18px 3px ${theme.palette.primary.boxShadow1Lite}`,
    '&:hover': {
      border: `0.063rem solid ${theme.palette.primary.textColor2}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
      // boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow}, 0px 10px 14px 1px  ${theme.palette.primary.boxShadow}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow}`,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  disableCTA: {
    padding: '8px 24px',
    border: `0.063rem solid ${theme.palette.primary.textColor2}`,
    background: theme.palette.primary.buttonInactiveColor,
    pointerEvents: 'none',
    color: theme.palette.primary.contrastText,
  },
  summaryCard: {
    height: 'fit-content',
    width: '100%',
    borderRadius: '10px',
    boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
  },
  myCart: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  myCartSection: {
    p: 0,
  },
  summaryTitle: {
    mb: '2rem',
    [theme.breakpoints.down('sm')]: {
      mb: '1rem',
    },
  },
  itemSimContainer: {
    padding: '0 1rem 0.5rem 1rem',
  },
  faqContainerSuperMain: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '3.75rem',
    paddingBottom: '2rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '1.95rem',
    },
  },
});

export default styles;
